import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=811ae196"
import script from "./ReportForm.vue?vue&type=script&lang=js"
export * from "./ReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports